import React, { useEffect } from "react";
import "./work.css";
import { trackPortfolioVisit } from "../../utils/analytics";

function Work() {
  const ibmLink = "https://www.ibm.com/us-en";
  const netcampusLink = "https://netcampus.com/";
  const uvuLink = "https://uvuafrica.com/capaciti/";
  const motivityLink = "https://motivity.co.za/";

  useEffect(() => {
    // Track when Work section is loaded
    trackPortfolioVisit('work');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("card-in-view");
        } else {
          entry.target.classList.remove("card-in-view");
        }
      });
    });

    const elements = document.querySelectorAll(
      ".card-experience-Motivity, .card-experience-UVU, .card-experience-Netcampus, .card-experience-IBM"
    );
    elements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      elements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []);

  return (
    <div>
      {/*WORK EXPERIENCE section*/}
      <div className="center">
        <section id="work">
          <h1 className="heading">
            <span className="text autoplay"> WORK EXPERIENCE </span>
          </h1>
        </section>
      </div>


      {/*IBM South Africa*/}
      <div className="container">
        <div className="line-and-logos">
          <a href={ibmLink} target="_blank" rel="noreferrer">
            <img
              src="/images/IBM logo.png"
              alt="IBM"
              className="icon"
            />
          </a>
         
          <div className="vertical-line"></div>
        </div>

        <div className="card-container">
          <div className="card-experience-IBM">
            <p>
              <b>Position:</b> IBM Graduate Consultant<br></br>
              <b>Job type:</b> Contract <br></br>
              <b>Company:</b> IBM South Africa <br></br><br></br>
              <b>Location:</b> Sandton, Johannesburg <br></br>
              <b>Duration:</b> December 2025 - Present <br></br>
               <br></br>
              <b>Job description:</b> <br></br>
              • Design, configure, and support inbound (real-time) and outbound (batch) Customer Value Management (CVM)
              campaigns using HCL Unica Campaign and HCL Unica Interact, delivering personalised customer engagement
              solutions for Telkom.
              <br></br><br></br>
              • Translate business requirements into scalable campaign solutions by developing audience selection logic,
              offer matrices, treatment strategies, and Next Best Offer (NBO) decisioning while leveraging Oracle SQL for
              data validation, campaign testing, and troubleshooting.<br></br><br></br>
              • Leverage IBM Consulting Advantage (IBM Bob) and generative AI capabilities to accelerate internal project
              delivery, support solution development, generate technical documentation, and improve productivity across
              consulting engagements.<br></br><br></br>
              • Developed and presented a Telkom Request Planner (TRP) proof of concept to streamline campaign
              operations, centralise request intake, and improve workflow visibility, SLA tracking, and governance. Built
              the platform using Node.js, Express, and Oracle Database, incorporating role-based access control, audit
              trails, and operational reporting.
            </p>
            <a
              href="https://www.linkedin.com/posts/lusaduma-ok-mata_ibm-ibmconsulting-telkom-ugcPost-7485212007076556800-RKWn/?utm_source=share&utm_medium=member_desktop&rcm=ACoAADo8oKMB3upc7bOMAoVS1JDOAQlUz0mN94E"
              target="_blank"
              rel="noreferrer"
              className="linkedin-cta"
            >
              📌 Presentation of the TRP & the Next Gen CVM Transformation at the IBM and Telkom Marketing Showcase →
            </a>
          </div>
        </div>
      </div>

      
      {/*Netcampus Group*/}
      <div className="container">
        <div className="line-and-logos">
          <a href={netcampusLink} target="_blank" rel="noreferrer">
            <img
              src="/images/Netcampus.png"
              alt="Netcampus"
              className="icon"
            />
          </a>
          
            <div className="vertical-line"></div>
        </div>

        <div className="card-container">
          <div className="card-experience-Netcampus">
            <p>
              <b>Position:</b> A.I Intern - Software Developer Intern<br></br>
              <b>Job type:</b> Internship <br></br>
              <b>Company:</b> Netcampus Group <br></br><i>(with host placement at Mandela Legacy)</i><br></br><br></br>
              <b>Location:</b> Tygervalley, Cape Town <br></br>
              <b>Duration:</b> March 2025 - November 2025 <br></br>
               <br></br>
              <b>Job description:</b> <br></br>
              • Participated in structured training at Netcampus Group, developing skills in AI and cloud-based solutions. 
              <br></br><br></br>
              • Completed the Microsoft Certified: Azure AI Fundamentals certification, gaining foundational knowledge in
                Artificial Intelligence, machine learning concepts, and Microsoft Azure services. <br></br><br></br>
              • Placed at Mandela Legacy as a Software Developer Intern, where I applied AI concepts and enhanced my
                technical skills in a professional environment, in combination with my skills in software development.
            </p>
          </div>
        </div>
      </div>



      {/*CAPACITI - UVU*/}
      <div className="container">
        <div className="line-and-logos">
          <a href={uvuLink} target="_blank" rel="noreferrer">
            <img
              src="/images/UVU.png"
              alt="UVU Africa"
              className="icon"
            />
          </a>
         
          <div className="vertical-line"></div>
        </div>

        <div className="card-container">
          <div className="card-experience-UVU">
            <p>
              <b>Position:</b> Software Developer Intern - AWS Intern <br></br>
              <b>Job type:</b> Internship <br></br>
              <b>Company:</b> CapaCiTi Tech Career Accelerator (UVU Africa) 
              <br></br><i>(with host placements at Younglings Africa & Liquid Intelligent Technologies)</i>
              <br></br><br></br>
              <b>Location:</b> Salt River, Cape Town <br></br>
              <b>Duration:</b> July 2023 - January 2025 <br></br>
              <br></br>
              <b>Job description:</b> <br></br>
              • Completed 18-month Full Stack Software Development programme, including 6 months of intensive training at CapaCiTi. 
              <br></br><br></br>
              • Gained practical experience in web and application development during placement at Younglings Africa. <br></br><br></br>
              • Served as an AWS Intern at Liquid Intelligent Technologies, focusing on cloud solutions and infrastructure. 
              I also achieved the AWS Certified Cloud Practitioner – Foundational certification, demonstrating cloud fluency and 
              foundational AWS knowledge.
            </p>
          </div>
        </div>
      </div>



      {/*Motivity*/}
      <div className="container">
        <div className="line-and-logos">
          <a href={motivityLink} target="_blank" rel="noreferrer">
            <img
              src="/images/Motivity.png"
              alt="Motivity"
              className="icon"
            />
          </a>
          <div className="vertical-line"></div>
        </div>

        <div className="card-container">
          <div className="card-experience-Motivity">
            <p>
              <b>Position:</b> IT Intern <br></br>
              <b>Job type:</b> Internship <br></br>
              <b>Company:</b> Motivity ICT South Africa <br></br><br></br>
              <b>Location:</b> Century City, Cape Town <br></br>
              <b>Duration:</b> May 2023 - July 2023 <br></br>
              <br></br>
              <b>Job description:</b>
              <br></br>• I rotated through diverse departments, gaining exposure and on-the-job learning.<br></br><br></br>
              • Executed duties at workstations and client properties, providing assistance to back-office administrators.
              <br></br><br></br>
              • Engaged in tasks including writing Excel formulas for efficient data organization, contributing to a comprehensive 
              experience in diverse aspects of the environment.

            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Work;
